import { render, staticRenderFns } from "./PassShiftsModal.vue?vue&type=template&id=21d8fdae&scoped=true&lang=pug"
import script from "./PassShiftsModal.vue?vue&type=script&lang=js"
export * from "./PassShiftsModal.vue?vue&type=script&lang=js"
import style0 from "./PassShiftsModal.vue?vue&type=style&index=0&id=21d8fdae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8fdae",
  null
  
)

export default component.exports